import Immutable from "seamless-immutable";
import {
  GET_PAYMENT_STATUS_MESSAGE_REQUEST,
  GET_PAYMENT_STATUS_MESSAGE_SUCCESS,
  GET_PAYMENT_STATUS_MESSAGE_FAILURE,
  GET_CHAT_CONFIGURATION,
  GET_CHAT_CONFIGURATION_SUCCESS,
  GET_CHAT_CONFIGURATION_FAILURE,
  GET_CREATE_CHAT,
  GET_CREATE_CHAT_SUCCESS,
  GET_CREATE_CHAT_FAILURE,
  GET_CHAT_UPDATE,
  GET_CHAT_UPDATE_SUCCESS,
  GET_CHAT_UPDATE_FAILURE,
  GET_CHAT_MESSAGE,
  GET_CHAT_MESSAGE_SUCCESS,
  GET_CHAT_MESSAGE_FAILURE,
  GET_CREATE_MESSAGE,
  GET_CREATE_MESSAGE_SUCCESS,
  GET_CREATE_MESSAGE_FAILURE,
  GET_TWILIO_QUIT_QUEUE,
  GET_TWILIO_QUIT_QUEUE_SUCCESS,
  GET_TWILIO_QUIT_QUEUE_FAILURE,
  GET_SCHEDULE_CALL_BACK,
  GET_SCHEDULE_CALL_BACK_SUCCESS,
  GET_SCHEDULE_CALL_BACK_FAILURE,
  GET_DISABLED_TIME_LISTS,
  GET_DISABLED_TIME_LISTS_SUCCESS,
  GET_DISABLED_TIME_LISTS_FAILURE,
  CREATE_APPOINTMENT,
  CREATE_APPOINTMENT_SUCCESS,
  CREATE_APPOINTMENT_FAILURE,
  GET_PROFILE_LIST_REQUEST,
  GET_PROFILE_LIST_SUCCESS,
  GET_PROFILE_LIST_FAILURE,
  GET_CHAT_REPLY_STATUS,
  GET_CHAT_REPLY_STATUS_SUCCESS,
  GET_CHAT_REPLY_STATUS_FAILURE,
  CONNECT_LIVE_CHAT,
  CONNECT_LIVE_CHAT_SUCCESS,
  CONNECT_LIVE_CHAT_FAILURE,
  GET_INSIDER_CLIENT_INFO_REQUEST,
  GET_INSIDER_CLIENT_INFO_SUCCESS,
  GET_INSIDER_CLIENT_INFO_FAILURE,
  SINGTEL_PARTNERSHIP_LEADS_REQ,
  SINGTEL_PARTNERSHIP_LEADS_REQ_SUCCESS,
  SINGTEL_PARTNERSHIP_LEADS_REQ_FAILURE,
} from "../actions/policy";

const INITIAL_STATE = Immutable({
  paymentStatusMessage: null,
  chatConfiguration: null,
  createChat: null,
  chatUpdate: null,
  chatMessage: null,
  createMessage: null,
  quitTwilioQueue: null,
  scheduleCallBack: null,
  disableTimeList: null,
  createAppointment: null,
  profile: null,
  getChatReplyStatus: null,
  connectLiveChat: null,
  getInsiderClientInfo: null,
  singtelPartnershipLeads:null,
});

function policy(state = INITIAL_STATE, action) {
  switch (action.type) {
    case GET_PAYMENT_STATUS_MESSAGE_REQUEST:
      return state.setIn(["paymentStatusMessage", "loading"], true);
    case GET_PAYMENT_STATUS_MESSAGE_SUCCESS:
      return state
        .setIn(["paymentStatusMessage", "loading"], false)
        .setIn(["paymentStatusMessage", "items"], action.data);
    case GET_PAYMENT_STATUS_MESSAGE_FAILURE:
      return state.setIn(["paymentStatusMessage", "loading"], false);

    case GET_CHAT_CONFIGURATION:
      return state
        .setIn(["chatConfiguration", "loading"], true)
        .setIn(["chatConfiguration", "status"], false);
    case GET_CHAT_CONFIGURATION_SUCCESS:
      return state
        .setIn(["chatConfiguration", "loading"], false)
        .setIn(["chatConfiguration", "items"], action.data)
        .setIn(["chatConfiguration", "status"], true);
    case GET_CHAT_CONFIGURATION_FAILURE:
      return state
        .setIn(["chatConfiguration", "loading"], false)
        .setIn(["chatConfiguration", "status"], false);

    case GET_CREATE_CHAT:
      return state
        .setIn(["createChat", "loading"], true)
        .setIn(["createChat", "status"], false);
    case GET_CREATE_CHAT_SUCCESS:
      return state
        .setIn(["createChat", "loading"], false)
        .setIn(["createChat", "items"], action.data)
        .setIn(["createChat", "status"], true);
    case GET_CREATE_CHAT_FAILURE:
      return state
        .setIn(["createChat", "loading"], false)
        .setIn(["createChat", "status"], false);

    case GET_CHAT_UPDATE:
      return state
        .setIn(["chatUpdate", "loading"], true)
        .setIn(["chatUpdate", "status"], false);
    case GET_CHAT_UPDATE_SUCCESS:
      return state
        .setIn(["chatUpdate", "loading"], false)
        .setIn(["chatUpdate", "items"], action.data)
        .setIn(["chatUpdate", "status"], true);
    case GET_CHAT_UPDATE_FAILURE:
      return state
        .setIn(["chatUpdate", "loading"], false)
        .setIn(["chatUpdate", "status"], false);

    case GET_CHAT_MESSAGE:
      return state
        .setIn(["chatMessage", "loading"], true)
        .setIn(["chatMessage", "status"], false);
    case GET_CHAT_MESSAGE_SUCCESS:
      return state
        .setIn(["chatMessage", "loading"], false)
        .setIn(["chatMessage", "items"], action.data)
        .setIn(["chatMessage", "status"], true);
    case GET_CHAT_MESSAGE_FAILURE:
      return state
        .setIn(["chatMessage", "loading"], false)
        .setIn(["chatMessage", "status"], false);

    case GET_CREATE_MESSAGE:
      return state
        .setIn(["createMessage", "loading"], true)
        .setIn(["createMessage", "status"], false);
    case GET_CREATE_MESSAGE_SUCCESS:
      return state
        .setIn(["createMessage", "loading"], false)
        .setIn(["createMessage", "items"], action.data)
        .setIn(["createMessage", "status"], true);
    case GET_CREATE_MESSAGE_FAILURE:
      return state
        .setIn(["createMessage", "loading"], false)
        .setIn(["createMessage", "status"], false);

    case GET_TWILIO_QUIT_QUEUE:
      return state
        .setIn(["quitTwilioQueue", "loading"], true)
        .setIn(["quitTwilioQueue", "status"], false);
    case GET_TWILIO_QUIT_QUEUE_SUCCESS:
      return state
        .setIn(["quitTwilioQueue", "loading"], false)
        .setIn(["quitTwilioQueue", "items"], action.data)
        .setIn(["quitTwilioQueue", "status"], true);
    case GET_TWILIO_QUIT_QUEUE_FAILURE:
      return state
        .setIn(["quitTwilioQueue", "loading"], false)
        .setIn(["quitTwilioQueue", "status"], false);

    case GET_SCHEDULE_CALL_BACK:
      return state
        .setIn(["scheduleCallBack", "loading"], true)
        .setIn(["scheduleCallBack", "status"], false);
    case GET_SCHEDULE_CALL_BACK_SUCCESS:
      return state
        .setIn(["scheduleCallBack", "loading"], false)
        .setIn(["scheduleCallBack", "items"], action.data)
        .setIn(["scheduleCallBack", "status"], true);
    case GET_SCHEDULE_CALL_BACK_FAILURE:
      return state
        .setIn(["scheduleCallBack", "loading"], false)
        .setIn(["scheduleCallBack", "status"], false);

    case GET_DISABLED_TIME_LISTS:
      return state
        .setIn(["disableTimeList", "loading"], true)
        .setIn(["disableTimeList", "status"], false);
    case GET_DISABLED_TIME_LISTS_SUCCESS:
      return state
        .setIn(["disableTimeList", "loading"], false)
        .setIn(["disableTimeList", "items"], action.data)
        .setIn(["disableTimeList", "status"], true);
    case GET_DISABLED_TIME_LISTS_FAILURE:
      return state
        .setIn(["disableTimeList", "loading"], false)
        .setIn(["disableTimeList", "status"], false);

    case CREATE_APPOINTMENT:
      return state
        .setIn(["createAppointment", "loading"], true)
        .setIn(["createAppointment", "status"], false);
    case CREATE_APPOINTMENT_SUCCESS:
      return state
        .setIn(["createAppointment", "loading"], false)
        .setIn(["createAppointment", "items"], action.data)
        .setIn(["createAppointment", "status"], true);
    case CREATE_APPOINTMENT_FAILURE:
      return state
        .setIn(["createAppointment", "loading"], false)
        .setIn(["createAppointment", "status"], false);
    case GET_PROFILE_LIST_REQUEST:
      return state.setIn(["profile", "loading"], true);
    case GET_PROFILE_LIST_SUCCESS:
      return state
        .setIn(["profile", "loading"], false)
        .setIn(["profile", "items"], action.data);
    case GET_PROFILE_LIST_FAILURE:
      return state.setIn(["profile", "loading"], false);

    case GET_CHAT_REPLY_STATUS:
      return state
        .setIn(["getChatReplyStatus", "loading"], true)
        .setIn(["getChatReplyStatus", "status"], false);
    case GET_CHAT_REPLY_STATUS_SUCCESS:
      return state
        .setIn(["getChatReplyStatus", "loading"], false)
        .setIn(["getChatReplyStatus", "items"], action.data)
        .setIn(["getChatReplyStatus", "status"], true);
    case GET_CHAT_REPLY_STATUS_FAILURE:
      return state
        .setIn(["getChatReplyStatus", "loading"], false)
        .setIn(["getChatReplyStatus", "status"], false);

    case CONNECT_LIVE_CHAT:
      return state
        .setIn(["connectLiveChat", "loading"], true)
        .setIn(["connectLiveChat", "status"], false);
    case CONNECT_LIVE_CHAT_SUCCESS:
      return state
        .setIn(["connectLiveChat", "loading"], false)
        .setIn(["connectLiveChat", "items"], action.data)
        .setIn(["connectLiveChat", "status"], true);
    case CONNECT_LIVE_CHAT_FAILURE:
      return state
        .setIn(["connectLiveChat", "loading"], false)
        .setIn(["connectLiveChat", "status"], false);
    case GET_INSIDER_CLIENT_INFO_REQUEST:
      return state
        .setIn(["getInsiderClientInfo", "loading"], true)
        .setIn(["getInsiderClientInfo", "status"], false);
    case GET_INSIDER_CLIENT_INFO_SUCCESS:
      return state
        .setIn(["getInsiderClientInfo", "loading"], false)
        .setIn(["getInsiderClientInfo", "status"], true)
        .setIn(["getInsiderClientInfo", "items"], action.data);
    case GET_INSIDER_CLIENT_INFO_FAILURE:
      return state
        .setIn(["getInsiderClientInfo", "loading"], false)
        .setIn(["getInsiderClientInfo", "status"], false);

        case SINGTEL_PARTNERSHIP_LEADS_REQ:
          return state
            .setIn(["singtelPartnershipLeads", "loading"], true)
            .setIn(["singtelPartnershipLeads", "status"], false);
        case SINGTEL_PARTNERSHIP_LEADS_REQ_SUCCESS:
          return state
            .setIn(["singtelPartnershipLeads", "loading"], false)
            .setIn(["singtelPartnershipLeads", "status"], true)
            .setIn(["singtelPartnershipLeads", "items"], action.data);
        case SINGTEL_PARTNERSHIP_LEADS_REQ_FAILURE:
          return state
            .setIn(["singtelPartnershipLeads", "loading"], false)
            .setIn(["singtelPartnershipLeads", "status"], false);

    default:
      return state;
  }
}

export default policy;
